export const getSchoolClassesRoute = (): string => "/klassen";

export const getClassDetailsRoute = (schoolClassId: string): string => {
    return `${getSchoolClassesRoute()}/${schoolClassId}`;
};

// Counterpart of CLASSROOM_PREVIEW_PARAM in schoolClassHelpers.ts.
export const EXIT_PREVIEW_PARAM = "exitPreview";

/**
 * Exiting the classroom preview navigates here instead of logging out in place: ClassDetails
 * clears the class member session on load (the provider isn't mounted under /klassen) and then
 * strips the param, so back/refresh can't replay the logout.
 */
export const getClassDetailsExitPreviewRoute = (schoolClassId: string): string => {
    return `${getClassDetailsRoute(schoolClassId)}?${EXIT_PREVIEW_PARAM}=1`;
};

export const isExitPreviewSearch = (search: string): boolean => {
    return new URLSearchParams(search).get(EXIT_PREVIEW_PARAM) === "1";
};

export const getDownloadCodesRoute = (schoolClassId: string): string => {
    return `${getClassDetailsRoute(schoolClassId)}/codes`;
};

export const getCreationReturnPath = (schoolClassId: string): string => {
    return schoolClassId ? getClassDetailsRoute(schoolClassId) : "/assistent";
};

export const getStudentResultRoute = (shareId: string): string => {
    return `/result/${shareId}`;
};

export const getStudentResultExerciseRoute = (shareId: string, exerciseNumber: number): string => {
    return `${getStudentResultRoute(shareId)}/exercise/${exerciseNumber}`;
};
